<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header" />
          </div>

          <div class="modal-body text-center">
            <slot name="body" />
          </div>

          <div class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-container {
  $margin-top-modal-container: 10px;
  $margin-bottom-modal-container: 10px;
  //max-height: calc(100vh - #{$margin-top-modal-container} - #{$margin-bottom-modal-container});
  margin-top: $margin-top-modal-container;
  margin-bottom: $margin-bottom-modal-container;
  margin: auto;
  min-width: 500px;
}
.modal-wrapper {
  display: flex;
  position: fixed;
  min-width: 100vw;
  height: 100vh;
  overflow: scroll;
}
</style>
